// removed by extract-text-webpack-plugin
module.exports = {"nf-itec-desc__grid":"nf-itec-desc__grid","rt-table":"rt-table","rt-resizable-header-content":"rt-resizable-header-content","rt-td":"rt-td"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grids/ItemDescInfoGrid/ItemDescInfo.scss
// module id = 4986
// module chunks = 1